export default {
	startsWith: 'Inicia com',
	contains: 'Contém',
	notContains: 'Não contém',
	endsWith: 'Termina com',
	equals: 'É igual a',
	notEquals: 'Não é igual',
	noFilter: 'Sem filtro',
	lt: 'Menor que',
	lte: 'Menos que ou igual a',
	gt: 'Maior que',
	gte: 'Maior que ou igual a',
	dateIs: 'Data é',
	dateIsNot: 'Data não é',
	dateBefore: 'A data é antes',
	dateAfter: 'A data é depois',
	clear: 'claro',
	apply: 'Aplique',
	matchAll: 'Corresponder a todos',
	matchAny: 'Corresponder a Qualquer',
	addRule: 'Adicionar regra',
	removeRule: 'Remover Regra',
	accept: 'Sim',
	reject: 'Não',
	choose: 'Escolher',
	upload: 'Fazer upload',
	cancel: 'Cancelar',
	dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
	dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
	monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
	today: 'Hoje',
	weekHeader: 'Semana',
	firstDayOfWeek: 0,
	dateFormat: 'dd/mm/yy',
	weak: 'Fraco',
	medium: 'Médio',
	strong: 'Forte',
	passwordPrompt: 'Digite uma senha',
	emptyFilterMessage: 'Nenhum resultado encontrado',
	emptyMessage: 'Nenhuma opção disponível'
}